// TODO: Overhaul — delete this file once the consumer reporting/portfolio endpoint is reachable. Interim,
// it serves the overhaul path `…/reporting/portfolio` from the live legacy portfolio endpoint (API1
// `/v1/reporting/portfolio/{entityId}`, the same `PortfolioSnapshotCollectionDto`), so the summary tiles
// read real figures ahead of the endpoint — no fabricated data.
import { Client } from 'openapi-fetch';

import { ok } from '@views/investor/queries/overhaul-mock.util';

import { paths as accountOverhaulPaths } from '@core/schemas/account-overhaul-schema';
import { paths as api1Paths } from '@core/schemas/api1-schema';

interface GetInit {
  params?: { path?: { investorEntityId?: number } };
}

/**
 * A mock `ACCOUNT_OVERHAUL_CLIENT` fragment serving the portfolio-summary read from the live legacy
 * portfolio endpoint. Composed into the single overhaul seam (`createOverhaulMockClient`); handles only the
 * `…/reporting/portfolio` GET.
 */
export function createPortfolioSummaryMockClient(deps: { api1: Client<api1Paths> }): Client<accountOverhaulPaths> {
  return {
    async GET(_path: string, init?: GetInit) {
      const entityId = init?.params?.path?.investorEntityId;
      if (entityId === undefined) return ok(null);
      const { data, error, response } = await deps.api1.GET('/v1/reporting/portfolio/{entityId}', {
        params: { path: { entityId } },
      });
      if (error) return { data: undefined, error, response };
      return ok(data);
    },
    // Cast: this stub implements only the reporting/portfolio GET, not the whole overhaul surface.
  } as unknown as Client<accountOverhaulPaths>;
}
